const headers = {
  name: "Inventory request",
  navigate: {
    tabs: [
      {
        name: "Request",
        path: "/app/inventory/request",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
